import { skipToken, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { DashboardTransactionsDynamicSummaryParams } from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsDynamicSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

import { useDashboardApi } from './useDashboardApi';

export function useGetDashboardTransactionsDynamicSummary(
  params: DashboardTransactionsDynamicSummaryParams | null,
): {
  isLoading: boolean;
  summary?: TransactionsDynamicSummary;
  error?: string;
} {
  const translate = useTypedTranslate();
  const { api, aggregatedQueryKey } = useDashboardApi();

  const {
    data: summary,
    isLoading,
    error,
  } = useQuery<TransactionsDynamicSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/executed_transactions_amount_by_steps', aggregatedQueryKey, params],
    queryFn: params ? () => api.getTransactionsDynamicSummary(params) : skipToken,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isLoading, error: errorMessage };
}
